// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  configureInternalNavigationFromCMSUrl,
  isGymboree,
  updateUrlWithIcid,
} from '../../../../utils';
import Anchor from '../../atoms/Anchor';
import { BodyCopyVanilla } from '../../atoms/BodyCopy/views/BodyCopy';
import withStyles from '../../hoc/withStyles';
import buttonStyles from '../../atoms/Button/Button.style';

const BodyCopyButtonStyled = withStyles(BodyCopyVanilla, buttonStyles);

const AnchorStyled = styled(Anchor)`
  ${(props) =>
    props.isCtaDropDownStackedGroup || props.isModuleDCtaDropDownStackedGroup
      ? `
  flex-grow: 1;
  width: 50%;

  `
      : ``}
  span {
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
  }
`;

const getClassNameVal = (isCtaDropDownGroup, isModuleDCtaDropDownGroup) => {
  if (isCtaDropDownGroup) {
    if (isGymboree()) {
      return 'gym-cta-grp-button-item-text';
    }
    return 'cta-grp-button-item-text';
  }
  if (isModuleDCtaDropDownGroup) {
    if (isGymboree()) {
      return 'moduleD-gym-cta-grp-button-item-text';
    }
    return 'moduleD-cta-grp-button-item-text';
  }
  return 'cta-button-text';
};

/**
 * @desc This component generates button list. The three variations of buttonlist are:
 * This component uses Anchor and Button atoms to render button list
 * 1. stackedCTAList: Buttons are in the stacked form.

 * 2. scrollCTAList: In the web view, peek appears for the next button to slide.
 * The user can slide from left to right to see the next buttons.

 * 3. linkCTAList: Category list buttons with bottom border, just like link with underline
 */
const ButtonCTA = (props) => {
  const {
    uniqueKey,
    className,
    dataLocator,
    dataLocatorCTA,
    ctaInfo: { className: ctaClassName, ctaVariation, link },
    featured,
    fill,
    isCtaDropDownStackedGroup,
    isCtaDropDownGroup,
    isSingleCtaDropdownGroup,
    isStackedButtonListLengthEven,
    isModuleDCtaDropDownGroup,
    isModuleDCtaDropDownStackedGroup,
    moduleAnalyticsTag,
    ...otherProps
  } = props;

  const classNameVal = getClassNameVal(isCtaDropDownGroup, isModuleDCtaDropDownGroup);

  const { url, target, title, text, actualUrl, styledObjWeb } = link;

  let to = actualUrl;
  if (!actualUrl) {
    to = configureInternalNavigationFromCMSUrl(url);
  }
  const updatedToUrl = updateUrlWithIcid(to, moduleAnalyticsTag);
  const updatedCtaUrl = updateUrlWithIcid(url, moduleAnalyticsTag);
  return (
    <AnchorStyled
      key={uniqueKey}
      className={`${ctaClassName} ${featured ? 'full-width' : ''} ${
        isCtaDropDownGroup ? 'drop-down-grp-anchor' : ''
      }`}
      to={updatedToUrl}
      asPath={updatedCtaUrl}
      target={target}
      title={title || text}
      role="button"
      dataLocator={dataLocatorCTA || `${dataLocator}-link`}
      isCtaDropDownStackedGroup={isCtaDropDownStackedGroup}
      isModuleDCtaDropDownStackedGroup={isModuleDCtaDropDownStackedGroup}
    >
      <BodyCopyButtonStyled
        className={`${className || ''} ${classNameVal}`}
        component="span"
        buttonVariation={ctaVariation}
        dataLocator={dataLocator}
        overrideStyle={styledObjWeb}
        fill={fill}
        {...otherProps}
      >
        {text}
      </BodyCopyButtonStyled>
    </AnchorStyled>
  );
};

ButtonCTA.propTypes = {
  uniqueKey: PropTypes.string,
  className: PropTypes.string.isRequired,
  dataLocator: PropTypes.string.isRequired,
  dataLocatorCTA: PropTypes.string,
  ctaInfo: PropTypes.shape({
    ctaVariation: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    link: PropTypes.shape({
      url: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  featured: PropTypes.string,
  fill: PropTypes.string,
  isCtaDropDownStackedGroup: PropTypes.bool.isRequired,
  isCtaDropDownGroup: PropTypes.bool.isRequired,
  isSingleCtaDropdownGroup: PropTypes.bool.isRequired,
  isStackedButtonListLengthEven: PropTypes.bool.isRequired,
  isModuleDCtaDropDownGroup: PropTypes.bool.isRequired,
  isModuleDCtaDropDownStackedGroup: PropTypes.bool.isRequired,
};

ButtonCTA.defaultProps = {
  uniqueKey: '',
  dataLocatorCTA: '',
  featured: null,
  fill: '',
};

export default ButtonCTA;
